<template>
    <sa-page-layout :btnRefreshVisible="true" :btnBackVisible="false" @refresh="onRefresh" :showModalLoading="showModalLoading" :linkback="linkback">
        <template #toolbar v-if="activeTabId === 'tbRiepilogoImpegnative' || activeTabId === 'tbRiepilogoPresenze'">
            <b-button variant="primary btn-toolbar sa-margin-right float-sm-right" size="sm" @click="onScaricaCsv"> <font-awesome-icon icon="file-csv" />Download Csv</b-button>
        </template>
        <template #table-body>
            <sa-tabs-scroll-component idTab="tabsRsaRiepiloghi" classNavItem="nav-item" />
            <b-tabs id="tabsRsaRiepiloghi" ref="tabsRsaRiepiloghi" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
                <b-tab id="tbRiepilogoImpegnative" title="RIEPILOGO IMPEGNATIVE" active>
                    <div class="sa-tab-scrol">
                        <div class="sa-flexbox">
                            <div v-if="activeTabId === 'tbRiepilogoImpegnative'" class="sa-flexbox-header" style="padding-top: 5px; padding-bottom: 10px">
                                <div class="sa-page-search-component">
                                    <b-form style="width: 100%" @submit.prevent="onSubmitRiepilogoImpegnative">
                                        <b-row class="sa-form-btn-filter">
                                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                                <label class="sa-label-data">Ospite</label>
                                                <input class="sa-page-search-component-input" v-model="filtroRiepilogoImpegnative.ospite" placeholder="Inserisci nome..." />
                                                <button class="sa-page-search-component-btn-search" title="Search">
                                                    <i class="fas fa-search"></i>
                                                </button>
                                            </b-col>

                                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                                <label class="sa-label-data">Setting</label>
                                                <input class="sa-page-search-component-input" v-model="filtroRiepilogoImpegnative.setting" placeholder="Inserisci setting..." />
                                                <button class="sa-page-search-component-btn-search" title="Search">
                                                    <i class="fas fa-search"></i>
                                                </button>
                                            </b-col>

                                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                                <label class="sa-label-data">Livello</label>
                                                <input class="sa-page-search-component-input" v-model="filtroRiepilogoImpegnative.livelli" placeholder="Inserisci livello..." />
                                                <button class="sa-page-search-component-btn-search" title="Search">
                                                    <i class="fas fa-search"></i>
                                                </button>
                                                <button class="sa-page-search-component-btn-reset" @click="resetFiltriRiepilogoImpegnative" type="button"><i class="fas fa-trash"></i></button>
                                            </b-col>
                                        </b-row>
                                    </b-form>
                                </div>
                            </div>
                            <div class="sa-flexbox-body">
                                <rsa-riepiloghi-riepilogo-impegnative-list-component ref="cmpRiepilogoImpegnative" @beforeLoadData="beforeLoadData" @afterLoadData="afterLoadData" />
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab id="tbRiepilogoOperatori" title="RIEPILOGO OPERATORI">
                    <div class="sa-tab-scrol">
                        <rsa-paziente-riepilogo-operatori-list-component v-if="activeTabId === 'tbRiepilogoOperatori'" ref="cmpRiepilogoOperatori" @afterLoadData="afterLoadData" />
                    </div>
                </b-tab>
                <b-tab id="tbRiepilogoAccessiADI" title="RIEPILOGO ACCESSI A.D.I">
                    <div class="sa-tab-scrol">
                        <rsa-riepilogo-accessi-adi-list-component v-if="activeTabId === 'tbRiepilogoAccessiADI'" ref="cmpRiepilogoAccessiAdi" @afterLoadData="afterLoadData" />
                    </div>
                </b-tab>
                <b-tab id="tbRiepilogoPresenze" title="RIEPILOGO PRESENZE">
                    <div class="sa-tab-scrol">
                        <div v-if="activeTabId === 'tbRiepilogoPresenze'" class="sa-list-component-header" style="padding-top: 5px; padding-bottom: 10px">
                            <date-filter-component ref="cmpDateFilterComponent" @change="onChangeRiepilogoPresenze"></date-filter-component>
                        </div>
                        <rsa-riepilogo-presenze-list-component @afterLoadData="afterLoadData" ref="cmpRsaRiepilogoPresenzeListComponent" />
                    </div>
                </b-tab>
                <b-tab id="tbRiepilogoPai" title="P.A.I.">
                    <div class="sa-tab-scrol">
                        <!--   <div v-if="activeTabId === 'tbRiepilogoPresenze'" class="sa-list-component-header" style="padding-top: 5px; padding-bottom: 10px">
                            <date-filter-component ref="cmpDateFilterComponent" @change="onChangeRiepilogoPresenze"></date-filter-component>
                        </div>
                        <rsa-riepilogo-presenze-list-component @afterLoadData="afterLoadData" ref="cmpRsaRiepilogoPresenzeListComponent" /> -->
                        <rsa-paziente-pai-domiciliare-list-component ref="cmpRsaPazientePaiDomicialiareList"></rsa-paziente-pai-domiciliare-list-component>
                    </div>
                </b-tab>
            </b-tabs>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import SaTabsScrollComponent from "../../../../template/components/utility/SaTabsScrollComponent.vue";
import RsaRiepiloghiRiepilogoImpegnativeListComponent from "../components/RsaRiepiloghiRiepilogoImpegnativeListComponent.vue";
import RsaPazienteRiepilogoOperatoriListComponent from "../../rsagestioneospiti/components/RsaPazienteRiepilogoOperatoriListComponent.vue";
import RsaRiepilogoAccessiAdiListComponent from "../../rsagestioneospiti/components/RsaRiepilogoAccessiAdiListComponent.vue";
import DateFilterComponent from "../../../utility/components/DateFilterComponent.vue";
import RsaRiepilogoPresenzeListComponent from "../../riepilogopresenze/components/RsaRiepilogoPresenzeListComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaPazientePaiDomiciliareListComponent from "../../rsapaziente/components/RsaPazientePaiDomiciliareListComponent.vue";

export default {
    mixins: { UtilityMixin },
    components: {
        SaPageLayout,
        SaTabsScrollComponent,
        RsaRiepiloghiRiepilogoImpegnativeListComponent,
        RsaPazienteRiepilogoOperatoriListComponent,
        RsaRiepilogoAccessiAdiListComponent,
        RsaRiepilogoPresenzeListComponent,
        DateFilterComponent,
        RsaPazientePaiDomiciliareListComponent,
    },
    data() {
        return {
            activeTabIndex: 0,
            idSoggetto: null,
            showModalLoading: false,
            linkback: "/home",
            activeTabId: "tbRiepilogoImpegnative",
            filtroRiepilogoImpegnative: {
                ospite: null,
                setting: null,
                livelli: null,
            },
            filtroRiepilogoPresenze: {},
            columnsProperty: [],
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage.getItem("filtroRiepilogoImpegnative")) {
            me.filtroRiepilogoImpegnative = JSON.parse(sessionStorage.getItem("filtroRiepilogoImpegnative"));
        }
        me.activeTab("tbRiepilogoImpegnative");
    },
    methods: {
        onInputTabs(index) {
            let activeTab = this.$refs.tabsRsaRiepiloghi.getTabs()[index];
            this.activeTabId = activeTab.id;
            this.activeTab(activeTab.id);
        },
        activeTab(idActiveTab) {
            switch (idActiveTab) {
                case "tbRiepilogoImpegnative":
                    this.columnsProperty = [
                        { key: "ospite", type: "string", label: "Nome e cognome", visible: true },
                        { key: "setting", type: "string", label: "Setting", visible: true },
                        { key: "livelli", type: "string", label: "Livello", visible: true },
                        { key: "impegnativaTipo", type: "string", label: "Prestazione", visible: true },
                        { key: "trattamentoDataInizio", type: "date", label: "Data inizio trattamento", visible: true },
                        { key: "trattamentoDataFine", type: "date", label: "Data fine trattamento", visible: true },
                        { key: "quotaAsl", type: "string", label: "Quota ASL", visible: true },
                        { key: "quotaComune", type: "string", label: "Quota Comune", visible: true },
                        { key: "quotaTotale", type: "string", label: "Quota Totale", visible: true },
                    ];
                    this.loadRiepilogoImpegnative();
                    break;
                case "tbRiepilogoOperatori":
                    this.$nextTick(() => {
                        if (this.$refs.cmpRiepilogoOperatori && this.$refs.cmpRiepilogoOperatori.loadData) {
                            this.beforeLoadData();
                            this.$refs.cmpRiepilogoOperatori.loadData();
                        }
                    });
                    break;
                case "tbRiepilogoAccessiADI":
                    this.$nextTick(() => {
                        if (this.$refs.cmpRiepilogoAccessiAdi && this.$refs.cmpRiepilogoAccessiAdi.init) {
                            this.beforeLoadData();
                            this.$refs.cmpRiepilogoAccessiAdi.init();
                        }
                    });
                    break;
                case "tbRiepilogoPresenze":
                    this.$nextTick(() => {
                        const f = this.$refs.cmpDateFilterComponent.getFilter();
                        this.beforeLoadData();
                        this.$refs.cmpRsaRiepilogoPresenzeListComponent.loadData({
                            dataDal: f.dataDal,
                            dataAl: f.dataAl,
                        });
                        this.columnsProperty = [
                            { key: "dataNascita", type: "date", label: "Data Nascita", visible: true },
                            { key: "cognome", type: "string", label: "Cognome", visible: true },
                            { key: "nome", type: "string", label: "Nome", visible: true },
                            { key: "identificativo", type: "string", label: "Identificativo", visible: true },
                            { key: "aslAppartenenza", type: "string", label: "Asl Appartenenza", visible: true },
                            { key: "distrettoAppartenenza", type: "string", label: "Distretto Appartenenza", visible: true },
                            { key: "comuneAppartenenza", type: "string", label: "Comune Appartenenza", visible: true },
                            { key: "giorniPresenza", type: "string", label: "Giorni Presenza", visible: true },
                            { key: "numeroGiorniAssenza", type: "string", label: "Numero Giorni Assenza", visible: true },
                            { key: "giorniAssenza", type: "string", label: "Giorno Assenza", visible: true },
                            { key: "dataRicovero", type: "date", label: "Data Ricovero", visible: true },
                            { key: "dataRicovero", type: "string", label: "Data Ricovero", visible: true },
                            { key: "dataScadenzaImpegnativa", type: "date", label: "Data Scadenza Impegnativa", visible: true },
                            { key: "dataAutorizzazioneImpegnativa", type: "date", label: "Data Autorizzazione Impegnativa", visible: true },
                            { key: "numeroAutorizzazioneImpegnativa", type: "string", label: "Numero Autorizzazione Impegnativa", visible: true },
                            { key: "strutturaDenominazione", type: "string", label: "Struttura", visible: true },
                            { key: "presidioDenominazione", type: "string", label: "Presidio", visible: true },
                            { key: "setting", type: "string", label: "Setting", visible: true },
                            { key: "livello", type: "string", label: "Livello", visible: true },
                        ];
                    });
                    break;
                case "tbRiepilogoPai":
                    this.$refs.cmpRsaPazientePaiDomicialiareList.initRiepilogo();

                    break;
            }
        },
        onSubmitRiepilogoImpegnative() {
            this.loadRiepilogoImpegnative();
        },
        loadRiepilogoImpegnative() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroRiepilogoImpegnative", JSON.stringify(me.filtroRiepilogoImpegnative));
            this.$refs.cmpRiepilogoImpegnative.loadData(me.filtroRiepilogoImpegnative);
        },
        beforeLoadData() {
            this.showModalLoading = true;
        },
        afterLoadData(loadList) {
            let me = this;
            this.showModalLoading = false;
            me.items = loadList;
        },
        onRefresh() {
            let tabId = this.$refs.tabsRsaRiepiloghi.getTabs()[this.activeTabIndex].id;
            this.activeTab(tabId);
        },
        resetFiltriRiepilogoImpegnative() {
            let me = this;
            let sessionStorage = window.sessionStorage;

            this.filtroRiepilogoImpegnative = { nome: null, cognome: null, setting: null, livello: null };
            sessionStorage.setItem("filtroRiepilogoImpegnative", JSON.stringify(me.filtroRiepilogoImpegnative));
            this.loadRiepilogoImpegnative();
        },
        onChangeRiepilogoPresenze(filtro) {
            if (this.$refs.cmpRsaRiepilogoPresenzeListComponent && this.$refs.cmpRsaRiepilogoPresenzeListComponent.loadData) {
                this.$refs.cmpRsaRiepilogoPresenzeListComponent.loadData({
                    dataDal: filtro.dataDal,
                    dataAl: filtro.dataAl,
                });
            }
        },
        onScaricaCsv() {
            var data = [];
            let csvHeaderFinal = [];
            let csvKeysFinal = [];
            let ketToInclude = {};

            if (this.items.length > 0) {
                for (let column of this.columnsProperty) {
                    if (!ketToInclude[column.key]) {
                        ketToInclude[column.key] = {
                            type: column.type ? column.type : "string",
                            label: column.label ? column.label : column.key.toUpperCase(),
                            visible: column.visible ?? true,
                        };
                    }
                }

                Object.keys(this.items[0]).forEach((key) => {
                    if (ketToInclude[key] && ketToInclude[key].visible) {
                        csvKeysFinal.push(key);
                        csvHeaderFinal.push(ketToInclude[key].label);
                    }
                });

                data.push(csvHeaderFinal);

                this.items.forEach((item) => {
                    let row = [];
                    csvKeysFinal.forEach((key) => {
                        let valore = item[key];
                        if (ketToInclude[key].type == "date") {
                            if (valore) {
                                valore = UtilityMixin.methods.formatDate(valore);
                            }
                        }
                        row.push(valore);
                    });
                    data.push(row);
                });
            }
            let dataString = "";
            var csvContent = "";
            data.forEach(function (infoArray, index) {
                dataString = infoArray.join(";");
                csvContent += index < data.length ? dataString + "\n" : dataString;
            });

            // The download function takes a CSV string, the filename and mimeType as parameters
            // Scroll/look down at the bottom of this snippet to see how download is called
            var download = function (content, fileName, mimeType) {
                var a = document.createElement("a");
                mimeType = mimeType || "application/octet-stream";

                if (navigator.msSaveBlob) {
                    // IE10
                    navigator.msSaveBlob(
                        new Blob([content], {
                            type: mimeType,
                        }),
                        fileName,
                    );
                } else if (URL && "download" in a) {
                    //html5 A[download]
                    a.href = URL.createObjectURL(
                        new Blob([content], {
                            type: mimeType,
                        }),
                    );
                    a.setAttribute("download", fileName);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                } else {
                    location.href = "data:application/octet-stream," + encodeURIComponent(content); // only this mime type is supported
                }
            };

            download(csvContent, "dowload.csv", "text/csv;encoding:utf-8");
        },
    },
};
</script>

<style scoped>
/* niente scroll qui: deve restare layout */
.sa-tab-scrol {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0; /* IMPORTANTISSIMO per flex + scroll interni */
    overflow: hidden; /* lo scroll NON deve essere qui */
    padding: 5px 10px 35px 10px;
}

/* area che si espande e contiene la lista */
.sa-tab-body {
    flex: 1 1 auto;
    min-height: 0; /* IMPORTANTISSIMO */
    overflow: hidden; /* lo scroll lo farà il list-component */
}

.sa-btn-search-submit {
    position: static !important;
    right: auto !important;
    bottom: auto !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
</style>
